<template>
  <div v-if="load&&current" class="GiftRoom" :style="{'aspectRatio':current.width/current.height}">
    <div class="bg"><img :src=current.ani alt="" @load="imgOnLoad" id="webp"></div>
    <template v-if="showWidget">
      <div :class="`widget ${item.type}`"
           :key="index"
           v-for="(item,index) in (current?.widget||[])"
      >

        <div class="widgetItem" :style="getStyles(item.style)"
             v-if="!(item.field === 'totalPrice' && !current.totalPrice) && item.hidden !== true">

          <div :style="{...item.itemStyle,...item.aniStyle||{}}">{{ getText(item) }}
            <img v-if="item.itemChildren1Style" :style="{...item.itemChildren1Style||{}}"
                 :src="item.faceBj"
                 alt="">
            <img v-if="item.itemChildren2Style" :style="{...item.itemChildren2Style||{}}"
                 :src="getFaceUrl()"
                 alt="">
            <img v-if="item.itemChildren3Style" :style="{...item.itemChildren3Style||{}}"
                 :src="item.faceBjd"
                 alt="">
            <div v-if="item.itemChildrenTextStyle" :style="{...item.itemChildrenTextStyle||{}}">{{ getChildrenText(item) }}</div>
          </div>

        </div>

      </div>
    </template>
  </div>
</template>

<script>
import 'animate.css'
import ChatClientTest from "@/api/chat/ChatClientTest"
import ChatClientRelay from "@/api/chat/ChatClientRelay"
import ChatClientDirectWeb from "@/api/chat/ChatClientDirectWeb"
import ChatClientDirectOpenLive from "@/api/chat/ChatClientDirectOpenLive"
import { getGiftSkins } from "@/api/client"
import { getUuid4Hex, toBool, toFloat } from "@/utils"
import { getLiveChatProductsByCoreApi } from "@/api/livechat/livechat";

export default {
  name: "GiftRoom",
  props: {
    roomKeyType: {
      type: Number,
      default: 1
    },
    roomKeyValue: {
      type: [Number, String],
      default: null
    },
    strConfig: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      config: {},
      chatClient: null,
      aniList: [], // 待播放动画列表
      current: null, // 当前播放的动画
      load: false,
      skin: null,
      timer: null,
      assetsList: [],
      fontList: [],
      ratio: 1,
      showWidget: false,
      stepTime: 1000,
      play3TimesSkin: ['XS6GyB8JV4oacBZeipw2qsq5cWkjfNhn', 'SCdLKeJtYRITwoGuI5HHwkjJC4EbTo22'],
      // "guard_level": 3, //对应的大航海等级 1总督 2提督 3舰长
      guardLevel1Data: {
        id: getUuid4Hex(),
        avatarUrl: 'https://2023blivechat.oss-cn-hangzhou.aliyuncs.com/%E5%9B%BE%E6%A0%87/fafa.png',
        timestamp: new Date().getTime() / 1000,
        authorName: '小杨',
        totalPrice: '198.00',
        privilegeType: 3,
        guardNum: 1,
        guardUnit: '月'
      },
      guardLevel2Data: {
        id: getUuid4Hex(),
        avatarUrl: 'https://2023blivechat.oss-cn-hangzhou.aliyuncs.com/%E5%9B%BE%E6%A0%87/fafa.png',
        timestamp: new Date().getTime() / 1000,
        authorName: '小杨',
        totalPrice: '1998.00',
        privilegeType: 2,
        guardNum: 1,
        guardUnit: '月'
      },
      guardLevel3Data: {
        id: getUuid4Hex(),
        avatarUrl: 'https://2023blivechat.oss-cn-hangzhou.aliyuncs.com/%E5%9B%BE%E6%A0%87/fafa.png',
        timestamp: new Date().getTime() / 1000,
        authorName: '小杨',
        totalPrice: '19998.00',
        privilegeType: 1,
        guardNum: 1,
        guardUnit: '月'
      },
      sendGift3Data: {
        id: getUuid4Hex(),
        avatarUrl: 'https://2023blivechat.oss-cn-hangzhou.aliyuncs.com/%E5%9B%BE%E6%A0%87/fafa.png',
        timestamp: new Date().getTime() / 1000,
        authorName: '小杨',
        totalPrice: '100.00',
        giftName: '小杨',
        num: 1
      },
      // 查询参数
      queryParams: {
        categoryId: 29,
        platformId: 2,
        searchValue: null,
        productCore: null,
      }
    }
  },
  mounted() {
    this.aniTimer()
    this.getSkin()
    // if (document.visibilityState === 'visible') {
    //   // this.init()
    // } else {
    //   // 当前窗口不可见，延迟到可见时加载，防止OBS中一次并发太多请求（OBS中浏览器不可见时也会加载网页，除非显式设置）
    //   document.addEventListener('visibilitychange', this.onVisibilityChange)
    // }
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
    if (this.chatClient) {
      this.chatClient.stop()
    }
  },
  created() {
    window.addEventListener("resize", this.onResize)
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      if (this.current) {
        this.ratio = document.body.clientWidth / this.current.width
      }
    },
    getStyles(style = {}) {
      let newStyle = {
        ...style,
        zoom: `${this.ratio}`,
      }
      // if (style.left) {
      //   newStyle.left = `${parseFloat(style.left) * this.ratio}px`
      // }
      // if (style.top) {
      //   newStyle.top = `${parseFloat(style.top) * this.ratio}px`
      // }
      // if (style.right) {
      //   newStyle.right = `${parseFloat(style.right) * this.ratio}px`
      // }
      // if (style.bottom) {
      //   newStyle.bottom = `${parseFloat(style.bottom) * this.ratio}px`
      // }

      let ratioList = Object.keys(style).filter(e => {
        return e.indexOf('margin') !== -1
      })

      if (ratioList.length) {
        for (let x = 0; x < ratioList.length; x++) {
          newStyle[ratioList[x]] = style[ratioList[x]].replace(/(\d+\.?\d|)px/g, params => {
            return `${parseFloat(params) * this.ratio}px`
          })
        }
      }


      return newStyle
    },
    getText(item) {
      let str = item.strTemplate
      if (str === '') {
        return this.current[item?.field]
      }
      Object.keys(this.current).forEach(key => {
        str = str.replaceAll(`{${key}}`, this.current[key])
      })
      return str
    },
    getChildrenText(item) {
      let str = item.itemChildrenTextStyle.strTemplate
      if (str === '') {
        return this.current[item?.field]
      }
      Object.keys(this.current).forEach(key => {
        str = str.replaceAll(`{${key}}`, this.current[key])
      })
      return str
    },
    getFaceUrl() {
      console.log(this.current.avatarUrl)
      return this.current.avatarUrl
    },
    getSkin() {
      this.queryParams.searchValue = this.roomKeyValue
      if (this.queryParams.searchValue === null) {
        this.queryParams.searchValue = 'test'
      }
      this.queryParams.productCore = this.strConfig.skin
      getLiveChatProductsByCoreApi(this.queryParams).then(res => {
        if (res.data) {
          let item = res.data.list.find(e => e.value === this.strConfig.skin)
          if (!item) {
            item = res.data.list.find(e => e.value === res.data.defaultValue)
          }
          if (!item) {
            throw Error('皮肤缺失，请重新生成链接')
          }

          this.skin = item
          // console.log("getGiftSkins:item=", item)
          const list = Object.keys(item.data).map(key => item.data[key].animation)
          // console.log("getGiftSkins:list=", list)
          const total = (item.fonts?.length || 0) + list.length
          // console.log("total:", total)
          const loading = this.$loading({
            lock: true,
            text: '加载资源中....',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          this.loadFonts(item.fonts, total, loading)
          this.loadAssets(list, total, loading)
          this.init()
        } else {
          throw Error('皮肤缺失，请重新生成链接')
        }
      }).catch(error => {
        this.$message.error("皮肤缺失，请重新生成链接")
        throw Error(error)
      })
    },
    loadAssets(list = [], total = 0, loading) {
      if (!list.length) {
        if (this.assetsList.length + this.fontList.length >= total) {
          loading.close()
          this.loadFinish()
        }
      }
      for (let i = 0; i < list.length; i++) {
        const listItemArray = list[i]
        // console.log("listItemArray=", listItemArray)
        for (let j = 0; j < listItemArray.length; j++) {
          const item = new Image()
          item.src = listItemArray[j]
          // console.log("item.src=", item.src)
          item.onload = () => {
            this.assetsList.push(item.src)
            item.remove()
            if (this.assetsList.length + this.fontList.length >= total) {
              loading.close()
              this.loadFinish()
            }
          }
        }
      }
    },
    loadFonts(list = [], total = 0, loading) {
      if (!list.length) {
        if (this.assetsList.length + this.fontList.length >= total) {
          loading.close()
          this.loadFinish()
        }
      }

      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        // 定义字体
        const font = new FontFace(item.name, `url(${item.url})`)
        // 把字体添加到 document.font（FontFaceSet）中
        document.fonts.add(font)
        // 加载字体
        font.load()
      }

      // 等待到所有的字体都加载完毕
      document.fonts.ready.then(() => {
        this.fontList = list
        if (this.assetsList.length + this.fontList.length >= total) {
          loading.close()
          this.loadFinish()
        }
      })
    },
    loadFinish() {
      if (this.load) {
        return
      }
      this.load = true
    },
    onVisibilityChange() {
      if (document.visibilityState !== 'visible') {
        return
      }
      document.removeEventListener('visibilitychange', this.onVisibilityChange)
      // this.init()
    },

    init() {
      if (this.roomKeyValue === null) {
        this.stepTime = 1500
      }
      this.initChatClient()
    },
    getTestMessageList() {
      let list = []
      if (!this.skin?.data) {
        return list
      }

      const showGift = toBool(this.strConfig.showGift)
      const showCaptain = toBool(this.strConfig.showGovernor)
      const showAdmiral = toBool(this.strConfig.showAdmiral)
      const showGovernor = toBool(this.strConfig.showCaptain)
      if (showGift) {
        list.push('gift')
      }
      if (showCaptain) {
        list.push('captain')
      }
      if (showAdmiral) {
        list.push('admiral')
      }
      if (showGovernor) {
        list.push('governor')
      }
      return list
    },
    initChatClient() {
      if (this.roomKeyValue === null) {
        const typeList = this.getTestMessageList()
        this.chatClient = new ChatClientTest(1000, 1000, typeList)
      } else if (this.config.relayMessagesByServer) {
        let roomKey = {
          type: this.roomKeyType,
          value: this.roomKeyValue
        }
        this.chatClient = new ChatClientRelay(roomKey, this.config.autoTranslate)
      } else {
        if (this.roomKeyType === 1) {
          this.chatClient = new ChatClientDirectWeb(this.roomKeyValue)
        } else {
          this.chatClient = new ChatClientDirectOpenLive(this.roomKeyValue, this.skin)


          const value = this.play3TimesSkin.indexOf(this.strConfig.skin)
          if (value > -1) {
            // 添加预播放数据
            this.onAddGift(this.sendGift3Data)
            this.onAddGift(this.sendGift3Data)
            this.onAddGift(this.sendGift3Data)

            this.onAddMember(this.guardLevel1Data)
            this.onAddMember(this.guardLevel1Data)
            this.onAddMember(this.guardLevel1Data)

            this.onAddMember(this.guardLevel2Data)
            this.onAddMember(this.guardLevel2Data)
            this.onAddMember(this.guardLevel2Data)

            this.onAddMember(this.guardLevel3Data)
            this.onAddMember(this.guardLevel3Data)
            this.onAddMember(this.guardLevel3Data)
          }


        }
      }
      this.chatClient.onAddGift = this.onAddGift
      this.chatClient.onAddMember = this.onAddMember
      this.chatClient.start()
    },

    start() {
      this.chatClient.start()
    },
    stop() {
      this.chatClient.stop()
    },

    onAddGift(data) {
      let item = {
        ...data,
        type: 'gift',
      }
      // console.log("item=", item)
      // console.log("item.totalPrice=", item.totalPrice)
      // item.totalPrice = item.totalPrice || ''
      const showGift = toBool(this.strConfig.showGift)
      const minGiftPrice = toFloat(this.strConfig.minGiftPrice, 0)
      if (!this.skin || !showGift || Number(item.totalPrice || 0) < minGiftPrice) {
        return false
      }
      if (!this.skin.data.gift) {
        return false
      }

      item.ani = this.skin.data.gift.animation[this.getRandomInt(this.skin.data.gift.animation.length)]
      item.time = this.skin.data.gift.time
      item.widget = this.skin.data.gift.widget
      item.width = this.skin.data.gift.width
      item.height = this.skin.data.gift.height
      // console.log(data.authorName)
      this.aniList.push(item)
    },

    getRandomInt(max) {
      return Math.floor(Math.random() * max)
    },

    onAddMember(data) {
      // console.log(data)
      let item = {
        ...data,
        type: 'member',
      }
      if (!this.skin) {
        return false
      }
      switch (item.privilegeType) {
      case 3:
        if (!toBool(this.strConfig.showCaptain) || !this.skin.data.captain) {
          return
        }
        item.ani = this.skin.data.captain.animation[this.getRandomInt(this.skin.data.captain.animation.length)]
        item.time = this.skin.data.captain.time
        item.widget = this.skin.data.captain.widget
        item.width = this.skin.data.captain.width
        item.height = this.skin.data.captain.height
        break
      case 2:
        if (!toBool(this.strConfig.showAdmiral) || !this.skin.data.admiral) {
          return
        }
        item.ani = this.skin.data.admiral.animation[this.getRandomInt(this.skin.data.admiral.animation.length)]
        item.time = this.skin.data.admiral.time
        item.widget = this.skin.data.admiral.widget
        item.width = this.skin.data.admiral.width
        item.height = this.skin.data.admiral.height
        break
      case 1:
        if (!toBool(this.strConfig.showGovernor) || !this.skin.data.governor) {
          return
        }
        item.ani = this.skin.data.governor.animation[this.getRandomInt(this.skin.data.governor.animation.length)]
        item.time = this.skin.data.governor.time
        item.widget = this.skin.data.governor.widget
        item.width = this.skin.data.governor.width
        item.height = this.skin.data.governor.height
        break
      }
      this.aniList.push(item)
    },
    // 定时从list里面播放动画
    aniTimer() {
      if (!this.load || !this.aniList.length) {
        setTimeout(this.aniTimer, 100)
        return false
      }
      if (this.current) {
        setTimeout(this.aniTimer, 100)
        return false
      }
      this.aniPlay()
      return true
    },
    aniPlay() {
      this.showWidget = false
      this.current = this.aniList[0]
      this.ratio = document.body.clientWidth / this.current.width
    },
    // 处理进场动画和出场动画
    transformAni() {
      this.current.widget.map(item => {
        const enterAniEndTime = parseFloat(item.enterAni.startTime) + (parseFloat(item.enterAni.style.animationDuration) * 1000)
        const liveAniEndTime = parseFloat(item.liveAni.startTime) + (parseFloat(item.liveAni.style.animationDuration) * 1000)
        item.hidden = true
        if (item.enterAni.startTime > 0) {
          setTimeout(() => {
            item.hidden = false
            item.aniStyle = item.enterAni.style
            this.current = { ...this.current }
          }, item.enterAni.startTime)
        } else {
          item.hidden = false
          item.aniStyle = item.enterAni.style
          this.current = { ...this.current }
        }
        //
        setTimeout(() => {
          item.aniStyle = {}
          this.current = { ...this.current }
        }, enterAniEndTime)

        setTimeout(() => {
          item.aniStyle = item.liveAni.style
          this.current = { ...this.current }
        }, item.liveAni.startTime)

        setTimeout(() => {
          item.aniStyle = {}
          this.current = { ...this.current }
          item.hidden = true
        }, Math.min(liveAniEndTime, this.current.time))
      })
      this.current = { ...this.current }
    },
    imgOnLoad() {
      this.showWidget = true
      this.transformAni()
      setTimeout(() => {
        this.aniList.shift()
        if (this.aniList.length > 0) {
          const webpItem = document.getElementById("webp")
          webpItem.src = this.aniList[0].ani
        }
        this.current = null
        setTimeout(this.aniTimer, this.stepTime)
      }, this.current.time || 2000)
    }
  }
}
</script>

<style scoped lang="less">
.GiftRoom {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: none;

  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;

    &.center {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.horizontalCenter {
      display: flex;
      align-items: flex-start;
      justify-content: center;
    }

    &.verticalCenter {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    &.topLeft {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }

    &.topRight {
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
    }

    &.bottomLeft {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
    }

    &.bottomRight {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
    }

    .widgetItem {

    }
  }

  .bg {
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
}
</style>
